const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 19.75a.75.75 0 0 1-.75-.75V5a.75.75 0 0 1 1.5 0v14a.75.75 0 0 1-.75.75m3.5 0a.75.75 0 0 1-.75-.75V5a.75.75 0 0 1 1.5 0v14a.75.75 0 0 1-.75.75m2.75-.75a.75.75 0 0 0 1.5 0V5a.75.75 0 0 0-1.5 0zm4.25.75a.75.75 0 0 1-.75-.75V5a.75.75 0 0 1 1.5 0v14a.75.75 0 0 1-.75.75m2.75-.75a.75.75 0 0 0 1.5 0V5a.75.75 0 0 0-1.5 0z"/></svg>';
export {
  a as w
};
